import { $api } from "../AxiosInstance";

export class MobileTariffService {
  static async getMobileTariffAll() {
    return await $api.get("/api/admin/mobileTariff/all");
  }

  static async getMobileTariffById(id) {
    return await $api.get("/api/admin/mobileTariff", { params: { id } });
  }

  static async saveMobileTariff(params) {
    return await $api.post("/api/admin/mobileTariff", params);
  }

  static async addMobileTariff(params) {
    return await $api.put("/api/admin/mobileTariff", params);
  }

  static async deleteMobileTariff(id) {
    return await $api.delete("/api/admin/mobileTariff", { params: { id } });
  }

  static async getSyncronizeMobileOperators() {
    return await $api.get("/api/admin/mobileTariff/update/crm");
  }

  static async changeIndicesMobileTariff(mobileTariffSortedIds) {
    return await $api.post("/api/admin/mobileTariff/changeIndices", {
      mobileTariffSortedIds,
    });
  }

  static async getTagsMobileOperatorsFromCRM() {
    return await $api.get("/api/admin/mobileTariff/tagsFromCRM");
  }
}
